import ajax from './ajax';
const baseUrl = '//m.gm99.com/ajax/';
const getArticleList = baseUrl + 'article_list';
const getGameInfo = baseUrl + 'get_game_info_new';
const getSlideList = baseUrl + 'article_slide_list';
const getArticleDetail = 'https://m.gm99.com/article/ajax_article_detail';
const service = {
  /**
   *
   * @param {string} 文章类型
   * @param {number} 游戏id
   * @param {number} 页码
   * @param {number} 每页多少条
   */
  getArticleList(type, articleID, gameID, page = 1, num = 5) {
    return new Promise((resolve, reject) => {
      const url =
        getArticleList +
        `?ids=${type}&gameID=${gameID}&page=${page}&num=${num}&orderBy=ORDER_INDEX&orderWay=DESC`;
      ajax
        .request({ url: url })
        .then(res => {
          if (res.result !== 1) {
            reject(err);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /**
   *
   * @param {number} 游戏id
   */
  getGameInfo(gameID) {
    return new Promise((resolve, reject) => {
      const url = getGameInfo + '?gameID=' + gameID;
      ajax
        .request({ url: url })
        .then(res => {
          if (res.result !== 1) {
            reject(err);
          }
          resolve(res);
        })
        .catch(err => {
        //  reject(err);
        });
    });
  },
  /**
   *
   * @param {number} 文章id
   */
  getArticleDetail(id) {
    return new Promise((resolve, reject) => {
      const url = getArticleDetail + '?id=' + id;
      ajax
        .request({ url: url })
        .then(res => {
          if (res.result !== 1) {
            reject(err);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getSlideList(gameID, site) {
    return new Promise((resolve, reject) => {
      const url =
        getSlideList +
        `?gameID=${gameID}&site=${site}&orderBy=RANK&orderWay=DESC&num=5`;
      ajax
        .request({ url: url })
        .then(res => {
          if (res.result !== 1) {
            reject(err);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
export default service;
